import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';

import componentStyles from './fil-hero-card.styles.js';

/**
 * @tag fil-hero-card
 * @property {string} [image] URL to an image
 * @property {"left"|"top"} [imagePosition] only use internally
 * @property {object} [link]
 * @property {string} [title] Headline
 * @property {boolean} [isCircle]
 */
export class FilHeroCard extends LitElement {
  static properties = {
    image: { type: String },
    imagePosition: { type: String }, // 'left' | 'top'
    link: { type: Object },
    title: { type: String },
    isCircle: { type: Boolean },
  };

  static styles = [componentStyles];

  connectedCallback() {
    // for a11y
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'listitem');
    }
    super.connectedCallback();
  }

  onClick() {
    const linkEle = this.shadowRoot.querySelector('.fil-hero-card__header a');
    linkEle.click();
  }

  renderTitle() {
    return html`<h2 class="fil-hero-card__header">
      <a href=${ifDefined(this.link?.url)} target=${ifDefined(this.link?.target)}>${this.title}</a>
    </h2>`;
  }

  render() {
    const classes = {
      [`fil-hero-card--image-${this.imagePosition}`]: this.imagePosition !== 'top',
      [`fil-hero-card--link`]: this.link?.url,
    };

    const imageClasses = {
      [`fil-hero-card__image--circle`]: this.isCircle,
    };

    return html`<div class="fil-hero-card${classMap(classes)}" @click=${this.onClick}>
      ${this.image
        ? html`<div class="fil-hero-card__image${classMap(imageClasses)}">
            <img src=${this.image} alt=${this.title} />
          </div>`
        : null}
      <div class="fil-hero-card__body">
        ${this.title ? this.renderTitle() : null}
        <div class="fil-hero-card__content" @click=${e => e.stopPropagation()}><slot></slot></div>
      </div>
    </div>`;
  }
}

export default FilHeroCard;
